import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsPage implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/terms/terms.component.ts